import { Heading, Stack, Box } from 'braid-design-system';
import React, { type ReactElement } from 'react';
interface Props {
  title: ReactElement | string;
  children: ReactElement;
}
const ProfileSection = ({ title, children }: Props) => (
  <div data-testid="profileSection">
    <Stack space="small">
      {typeof title === 'string' ? <Heading level="3">{title}</Heading> : title}
      <Box paddingTop="medium">{children}</Box>
    </Stack>
  </div>
);

export default ProfileSection;
